export default "__VITE_ASSET__DaeGQndX__"